import { createContext } from 'react';

import api from '../api';
import { Context } from '../../../types';
import { EmailTemplate } from '../types';

// Local rather than `lodash/noop`: the untyped lodash sub-path import is what makes
// the sibling contexts report an implicit-any error under `tsc --noEmit`.
const noop = () => {};

export default createContext<Context<EmailTemplate>>({
    get: api.get,
    getById: api.getById,
    getSchema: api.getSchema,
    schema: {},
    post: api.post,
    put: api.put,
    data: [],
    setData: noop,
    selected: null,
    setSelected: noop,
    remove: api.remove,
    error: null
});
